// extracted by mini-css-extract-plugin
export default {"emptyBlock":"not_found-module___emptyBlock___f1f532cf","emptyText":"not_found-module___emptyText___a56d2cc2"};